import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from "../store/index";


Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      showHeader: true,
      requiresAuth: true,

    }
  },

  {
    path: '/editBusinessProfile',
    name: 'edit',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/EditBProfile.vue')
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    meta: {
      showHeader: false,
      requiresAuth: false,

    },
    component: () => import('../views/Subscribe.vue')
  },

  {
    path: '/manageStaff',
    name: 'manage staff',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/ManageStaff.vue')
  },

  {
    path: '/editUser',
    name: 'edit',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/EditUserProfile.vue')
  },
  {
    path: '/changePassword',
    name: 'edit',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/ChangePassword.vue')
  },

  {
    path: '/addProduct',
    name: 'add product',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/AddProduct.vue')
  },

  {
    path: '/receipt/:id',
    name: 'receipts',
    meta: {
      showHeader: false,
      requiresAuth: true,
    },

    component: () => import('../views/Receipt.vue')
  },

  {
    path: '/makeSale',
    name: 'edit',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/MakeSale.vue')
  },

  {
    path: '/viewSale',
    name: 'edit',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/ViewSale.vue')
  },

  {
    path: '/stock/:id',
    name: 'stock',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/Stock.vue')
  },

  {
    path: '/saleReport',
    name: 'Report',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/SaleReport.vue')
  },
  {
    path: '/print/:id',
    name: 'Print',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/Printer.vue')
  },
  {
    path: '/',
    name: 'Login',
    meta: {
      showHeader: false
    },

    component: () => import('../views/Login.vue')
  },

  {
    path: '/product',
    name: 'Product',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/Product.vue')
  },
  {
    path: '/addProduct',
    name: 'Add Product',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },



    component: () => import('../views/AddProduct.vue')
  },

  {
    path: '/customers',
    name: 'customers',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },

    component: () => import('../views/ViewCustomer.vue')
  },
  {
    path: '/addCustomer',
    name: 'add customer',
    meta: {
      showHeader: true,
      requiresAuth: true,

    },



    component: () => import('../views/AddCustomer.vue')
  },

  {
    path: '/resetPassword',
    name: 'Reset Password',
    meta: {
      showHeader: false
    },

    component: () => import('../views/ResetPassword.vue')
  },

  {
    path: '/manageSubscribtion',
    name: 'Subscribtion',
    meta: {
      showHeader: true,
      requiresAuth: true,
    },

    component: () => import('../views/Subscribtion.vue')
  },

  {
    path: '/register',
    name: 'Register',

    component: () => import('../views/Register.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !store.state.user) {
    next("/");
  } else {
    next();
  }
});

export default router
